export default [
    {
        path: '/buying_tickets',
        name: '',
        component:() => import ( /* webpackChunkName: "group-be_myself" */ '@/views/be_myself/buying_tickets/index') ,
    },
    {
        path: '/buying_tickets_list',
        name: '',
        component:() => import ( /* webpackChunkName: "group-buying_tickets_list" */ '@/views/be_myself/buying_tickets_list/index') ,
    },
    {
        path: '/buying_tickets_details',
        name: '',
        component:() => import ( /* webpackChunkName: "group-buying_tickets_list" */ '@/views/be_myself/buying_tickets_details/index') ,
    },
    {
        path: '/buying_tickets_information',
        name: '',
        component:() => import ( /* webpackChunkName: "group-buying_tickets_list" */ '@/views/be_myself/buying_tickets_information/index') ,
    },
    {
        path: '/buying_tickets_success',
        name: '',
        component:() => import ( /* webpackChunkName: "group-buying_tickets_success" */ '@/views/be_myself/buying_tickets_success/index') ,
    },
    {
        path: '/buying_index',
        name: '',
        component:() => import ( /* webpackChunkName: "group-buying_tickets_success" */ '@/views/be_myself/buying_index/index') ,
    },
    {
        path: '/personal',
        name: '',
        component:() => import ( /* webpackChunkName: "group-buying_tickets_success" */ '@/views/be_myself/personal/index') ,
    },
    {
        path: '/bemyself_rank',
        name: '',
        component:() => import ( /* webpackChunkName: "group-bemyself_rank" */ '@/views/be_myself/bemyself_rank/index') ,
    }
]
